
import { ApiCall } from '@lcms/api-definition';
import endpoints from './api-endpoint-definition.json';

export type TrendingSearchTermsResponse = string[]

const definition = new ApiCall<TrendingSearchTermsResponse>().get('trendingSearchTerms', { route: endpoints.trendingSearchTerms })
export default definition;